






























import { computed, defineComponent, ref, PropType } from "@vue/composition-api";
import { Study } from "@/psychlab/types";
import { EditState } from "@/components.run/manage-study/ManageStudy";
import ButtonBase from "@/components.generic/button-base/button-base.vue";

export default defineComponent({
	components: {
		ButtonBase,
	},
	emits: ["rename", "cancelRename", "confirmRename"],
	props: {
		study: {
			type: Object as PropType<Study>,
			required: true,
		},
		editingName: {
			type: Object as PropType<EditState>,
			required: true,
		},
	},
	setup(props, context) {
		const nameInputRef = ref<HTMLInputElement | undefined>();
		const isFocused = ref(false);

		const isChanged = computed(
			() => props.study.name !== props.editingName?.value,
		);

		const handleRename = () => {
			if (nameInputRef.value) {
				nameInputRef.value.select();
			}
			context.emit("rename");
		};

		const handleCancelRename = () => {
			context.emit("cancelRename");
			nameInputRef.value?.blur();
		};

		const handleConfirmRename = () => {
			context.emit("confirmRename");
			nameInputRef.value?.blur();
		};

		return {
			nameInputRef,
			isFocused,
			handleRename,
			handleCancelRename,
			handleConfirmRename,
			isChanged,
		};
	},
});
